module.exports = __webpack_public_path__ + "fonts/RenaultLife-BoldItalic.woff";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/fonts/latin-basic/RenaultLife-BoldItalic.woff
// module id = 352
// module chunks = 0